const State = () => {
    return {
        stateExample: {
            something: 'initial-state'
        }
    }
}

export default State
